import {ConfirmModal, PersonSelect} from '@src/component/IModal'
import INavBar from '@src/component/INavBar'
import ISeleect from '@src/component/ISelect'
import VerticalSpace from '@src/component/VerticalSpace'
import CommonService from '@src/service/commonService'
import {getItemObj} from '@src/util/store'
import {InfiniteScroll, Space, Toast} from 'antd-mobile'
import React, {useRef, useState} from 'react'
import ClientCard from './components/clientCard'
import './index.scss'

interface Map {
    [key: string]: any

    [index: number]: any
}

const status: Map = {
    全部: null,
    已指派: 1,
    未指派: 2,
}
const contacted_status: Map = {
    全部: null,
    未联系: 0,
    已联系: 1,
}

function LeaveInfo() {
    const {isManager} = getItemObj('userInfo')
    const [clientList, setClientList] = useState<any[]>([])
    const baseParam = useRef({page: 1, size: 10})
    const [asignStatus, setAsignStatus] = useState<number | null>(null) // 是否指派
    const [contacted, setContacted] = useState<number | null>(null) // 是否联系

    const [selectVisible, setSelectVisible] = useState(false)
    const [modalType, setModalType] = useState('')

    const currentColumns =
        isManager === 1 ? [Object.keys(status)] : [Object.keys(contacted_status)]
    const currentId = useRef(0)
    const [hasMore, setHasMore] = useState(true)

    const loadMore = async () => {
        const params =
            isManager === 0
                ? {...baseParam.current, contacted}
                : {...baseParam.current, asignStatus}
        const {total, rows} = await CommonService.getPreloanList(params)
        let currentTotal = 0
        baseParam.current = {
            ...baseParam.current,
            page: baseParam.current.page + 1,
        }
        setClientList((val) => {
            const tempList = [...val, ...rows]
            currentTotal = tempList.length
            return tempList
        })
        setHasMore(rows.length > 0 && currentTotal < total)
    }

    // const chooseList = (val: string) => {
    //     isManager === 1
    //         ? setAsignStatus(status[val])
    //         : setContacted(contacted_status[val])
    //     baseParam.current = {
    //         ...baseParam.current,
    //         page: 1,
    //     }
    //     setClientList([])
    //     setHasMore(true)
    // }

    const pickSaler = (id: number, type: 'pick' | 'confirm') => {
        currentId.current = id
        if(type === 'confirm') {
            setModalType('confirm')
        } else if(type === 'pick') {
            setModalType('pick')
        }
        setSelectVisible(true)
    }

    const asign = (userId: any) => {
        CommonService.intensionAsign({
            id: currentId.current,
            asignDealerUserId: userId,
        }).then(() => {
            setSelectVisible(false)
            Toast.show('操作成功')
            baseParam.current = {
                ...baseParam.current,
                page: 1,
            }
            setClientList([])
            setHasMore(true)
        })
    }

    const okConfirm = () => {
        console.log(12)
        CommonService.contackMark({id: currentId.current}).then(() => {
            setSelectVisible(false)
            Toast.show('操作成功')
            baseParam.current = {
                ...baseParam.current,
                page: 1,
            }
            setClientList([])
            setHasMore(true)
        })
    }

    return (
        <>
            <INavBar title="客户留资"/>
            <div className="leave-wrapper">
                {isManager === 1 && (
                    <div className="notice-text">
                        <span>温馨提示：</span>
                        请及时联系客户，邀约客户到店；并告知客户金融分期需要提前准备的资料和获取方式。
                    </div>
                )}

                <VerticalSpace size={16}>
                    {clientList.length > 0 &&
                    clientList.map((client) => (
                        <ClientCard
                            key={client.id}
                            detail={client}
                            pickSaler={pickSaler}
                        />
                    ))}
                    <InfiniteScroll loadMore={loadMore} hasMore={hasMore}/>
                </VerticalSpace>
            </div>
            {selectVisible && modalType === 'pick' && (
                <PersonSelect
                    visible={selectVisible}
                    onOk={asign}
                    onCancel={() => setSelectVisible(false)}
                />
            )}
            {selectVisible && modalType === 'confirm' && (
                <ConfirmModal
                    visible={selectVisible}
                    onOk={okConfirm}
                    content="是否确认已联系客户？"
                    onCancel={() => setSelectVisible(false)}
                />
            )}
        </>
    )
}

export default LeaveInfo
